import type { DrawerItem } from '@/components/subject/configs.ts';

const experiments: DrawerItem[] = [
  {
    title: '5.数列求和与综合应用',
    icon: 'lucide:folder',
    children: [
      { title: '无限递归数列1', icon: 'lucide:flask-conical', route: `/experiment/infinite-recurrence1` },
    ],
  },
];

const experimentConfig = {
  experiments,
};

export { experimentConfig };
